import React from "react";
import styled from "styled-components";

const Title = styled.div`
  color: #000;
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
  margin-bottom: 6px;
`;

const Item = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 12px 0;
`;

const Label = styled.span`
  font-size: 12px;
  line-height: 14px;
  color: #5f6368;
`;

const Value = styled.span`
  font-size: 12px;
  line-height: 14px;
  font-weight: 500;
  color: #000;
`;

const LoanTerms = props => {
  const { items, title, dropshadowColor } = props;

  const Wrapper = styled.div`
    max-width: 271px;
    padding: 16px 16px 4px 16px;
    border: 1px solid #3c4d4f;
    border-radius: 4px;
    margin-top: 5px;
    box-shadow: -8px 8px 4px -2px #${dropshadowColor};
  `;

  return (
    <Wrapper>
      <Title>
        {title}
      </Title>
      {items.map(item => (
        <Item>
          <Label>{item.label}</Label>
          <Value>{item.value}</Value>
        </Item>
      ))}
    </Wrapper>
  );
};

export default LoanTerms;
